export default {
  mutations: {
    SET_PROFILE: 'SET_PROFILE',
    SET_PROFILES: 'SET_PROFILES',
    LOAD_CACHED_PROFILES: 'LOAD_CACHED_PROFILES',
    SET_LAST_GEOCODE_RESULTS: 'SET_LAST_GEOCODE_RESULTS'
  }
}
